import { Component, OnInit } from '@angular/core';
import {PromoBannerService} from '../promo-banner.service';

@Component({
    selector: 'app-promo-banner',
    templateUrl: './promo-banner.component.html',
    styleUrls: ['./promo-banner.component.scss'],
    standalone: false
})
export class PromoBannerComponent implements OnInit {

  private keyName = 'auditor-promo-banner';

  constructor(
    private promoBannerService: PromoBannerService
  ) { }

  ngOnInit() {
  }

  getSecondsToEndOfPeriod() {
    return this.promoBannerService.getSecondsToEndOfPeriod();
  }

  checkViewBanner(): boolean {
    return this.promoBannerService.checkViewBanner();
  }

  getPromoColor(): string {
    const d = new Date();
    const n = d.getDay();

    switch (n) {
      case 0:
        // return '#ff8ba7';
        return '#efb052';
      case 1:
        //return '#f45d48';
        return '#4ac488';
      case 2:
        return '#6246ea';
      case 3:
        return '#24aba6';
      case 4:
        return '#0e568b';
      case 5:
        return '#09523A';
      case 6:
        // return '#d9376e';
        return '#e54a7f';
    }

    return '';
  }

  getPromoName(): string {
    const d = new Date();
    const n = d.getDay();

    switch (n) {
      case 0:
        return 'Sunday';
      case 1:
        return 'Monday';
      case 2:
        return 'Tuesday';
      case 3:
        return 'Wednesday';
      case 4:
        return 'Thursday';
      case 5:
        return 'Friday';
      case 6:
        return 'Saturday';
    }

    return '';
  }

}
